(() => {
  const getText = (node) => (node ? node.textContent.replace(/\s+/g, ' ').trim() : '');

  const setImageAlt = () => {
    document.querySelectorAll('.n9-fbt-product-img, .n9-quickview-product-img').forEach((img) => {
      if (img.hasAttribute('alt') && img.getAttribute('alt').trim()) return;
      const root = img.closest('li, .n9Upsells-Product-Block, .modalUpsellProducts, n9-fbt') || document;
      const title =
        getText(root.querySelector('.n9-fbt-product-title, .n9-product-title, [data-essential-upsell-element="title"]')) ||
        getText(document.querySelector('.product__title, h1')) ||
        'Related sheet music';
      img.setAttribute('alt', title);
    });
  };

  const setControlNames = () => {
    document.querySelectorAll('.n9-fbt-btn-custom, .n9-quickview-btn-custom').forEach((button) => {
      if (button.getAttribute('aria-label') || getText(button)) return;
      button.setAttribute('aria-label', button.dataset.textAddSelected || 'Add selected product to cart');
    });

    document.querySelectorAll('.n9-fbt-add-checkbox').forEach((checkbox) => {
      if (checkbox.getAttribute('aria-label') || checkbox.getAttribute('aria-labelledby')) return;
      const root = checkbox.closest('li, .n9Upsells-Product-Block, .modalUpsellProducts, n9-fbt') || document;
      const title = getText(root.querySelector('.n9-fbt-product-title, .n9-product-title'));
      checkbox.setAttribute('aria-label', title ? `Include ${title}` : 'Include this bundle item');
    });

    document.querySelectorAll('.closeN9QuickView').forEach((control) => {
      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
      control.setAttribute('aria-label', 'Close quick view');
      if (control.dataset.jbA11yKeydown) return;
      control.dataset.jbA11yKeydown = 'true';
      control.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        control.click();
      });
    });
  };

  const normalizeAppIds = () => {
    const seen = new Map();
    const selector = [
      'n9-fbt [id]',
      '.modalUpsellProducts[id]',
      '.N9ProductUpsellsModal_QuickView[id]',
      '.n9Upsells-Product-Block[id]',
      '.closeN9QuickView[id]',
      '[id^="n9_"]',
      '[id^="n9-quickview"]',
      '[id^="N9QuickView"]'
    ].join(',');

    document.querySelectorAll(selector).forEach((element) => {
      const id = element.id;
      if (!id) return;
      const count = seen.get(id) || 0;
      seen.set(id, count + 1);
      if (count === 0) return;
      element.id = `${id}--a11y-${count + 1}`;
    });
  };

  const normalizeProductGalleryRoles = () => {
    document.querySelectorAll('.product__media-list[role="presentation"]').forEach((list) => {
      list.setAttribute('role', 'list');
    });
    document.querySelectorAll('.product__media-item[role="presentation"]').forEach((item) => {
      item.removeAttribute('role');
    });
  };

  const normalizePosterButtons = () => {
    const seen = new Map();

    document.querySelectorAll('.deferred-media__poster').forEach((button) => {
      if (!button.getAttribute('aria-label') && !getText(button)) {
        const isModel = Boolean(button.closest('product-model') || button.querySelector('.icon-3d-model'));
        button.setAttribute('aria-label', isModel ? 'Play 3D model' : 'Play video');
      }

      if (!button.id) return;
      const count = seen.get(button.id) || 0;
      seen.set(button.id, count + 1);
      if (count === 0) return;
      button.id = `${button.id}--poster-${count + 1}`;
    });
  };

  const run = () => {
    setImageAlt();
    setControlNames();
    normalizeAppIds();
    normalizeProductGalleryRoles();
    normalizePosterButtons();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(run, 1000);
})();
